// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"f6ae891b","433":"c2fcd471","704":"cf924436"}[chunkId] + ".chunk.js";
};